import React from 'react';

import AddProjectButton from './add-project-button/AddProjectButton';
import ProjectsTable from './projects-table/ProjectsTable';

function CompanyProjects() {
  return (
    <>
      <AddProjectButton />

      <ProjectsTable />
    </>
  );
}

export default CompanyProjects;
